<div class="loading">
    <spinner message="{{'CLIENT_CREDENTIALS.OAUTH.REDIRECTING'|translate}}"></spinner>
</div>